export default __webpack_public_path__ + "static/media/Obesity-1.0bd7ac1b.jpg";